<template>
  <div class="col-12">
    <!-- the WhatsApp service pages: QR scan, connected device, messages archive, API -->
    <nav class="wa-tabs" aria-label="خدمة الواتساب">
      <router-link v-for="t in tabs" :key="t.to" :to="t.to" class="wa-tab" exact-active-class="wa-tab-active">
        <i :class="'fa ' + t.icon"></i>
        <span>{{ t.title }}</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  computed: {
    tabs() {
      var t = [
        { to: '/_whatsapp/device', title: 'الجهاز المتصل', icon: 'fa-mobile' },
        { to: '/_whatsapp', title: 'فحص الجهاز (QR)', icon: 'fa-qrcode' },
        { to: '/_whatsapp/archive', title: 'أرشيف الرسائل', icon: 'fa-archive' },
      ];
      // the service token: the school account and '*' supervisors only
      if (checkPer('*')) t.push({ to: '/_whatsapp/api', title: 'الربط البرمجي API', icon: 'fa-code' });
      return t;
    },
  },
};
</script>

<style scoped>
.wa-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  margin-bottom: 16px;
  border-radius: 10px;
  background: rgba(29, 78, 216, 0.06);
}
.wa-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  color: inherit;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
}
.wa-tab:hover {
  background: rgba(29, 78, 216, 0.1);
  text-decoration: none;
}
.wa-tab-active,
.wa-tab-active:hover {
  background: #1d4ed8;
  color: #fff;
}
.wa-tab:focus-visible {
  outline: 2px solid #1d4ed8;
  outline-offset: 2px;
}
@media (max-width: 576px) {
  .wa-tab {
    flex: 1 1 45%;
    justify-content: center;
    font-size: 13px;
  }
}
</style>
